import { render, staticRenderFns } from "./GetInTouch.vue?vue&type=template&id=6e2581b0&scoped=true&"
import script from "./GetInTouch.vue?vue&type=script&lang=js&"
export * from "./GetInTouch.vue?vue&type=script&lang=js&"
import style0 from "./GetInTouch.vue?vue&type=style&index=0&id=6e2581b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2581b0",
  null
  
)

export default component.exports